import { render, staticRenderFns } from "./a34.vue?vue&type=template&id=2dd3b222&scoped=true"
import script from "./a34.vue?vue&type=script&lang=js"
export * from "./a34.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3b222",
  null
  
)

export default component.exports